import { render, staticRenderFns } from "./MhlvSummary.vue?vue&type=template&id=c3f4f49a"
import script from "./MhlvSummary.vue?vue&type=script&lang=js"
export * from "./MhlvSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports